<template>
  <div class="animated fadeIn">
    <div class="block-screen" v-if="loading"><i class="fa fa-refresh fa-spin"></i></div>
    <b-alert :show="dismissCountDown"
       dismissible
       variant="success"
       @dismissed="dismissCountDown=0"
       @dismiss-count-down="countDownChanged">
      <p>Participante atualizado com sucesso!</p>
      <b-progress variant="success"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px">
      </b-progress>
    </b-alert>
    <b-row>
      <b-col lg="12">
        <c-table striped caption="<i class='fa fa-users'></i> Lista de Participantes" :items="items"
          :fields="fields">
        </c-table>
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import cTable from '../../components/Table.vue'

  export default {
    name: 'tables',
    components: {cTable},
    data () {
      return {
        loading: false,
        dismissSecs: 10,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        items: [],
        fields: [
          {key: 'badge_name', label: 'Nome', sortable: true},
          {key: 'formatted_rank', label: 'Categoria', sortable: true},
          {key: 'registration', label: 'Matrícula', sortable: true},
          // {key: 'email', label: 'Email', sortable: true},
          {key: 'register_email', label: 'Email', sortable: true},
          {key: 'actions', label: 'Ações'}
        ]
      }
    },
    mounted () {
      if (this.$router.history.current.params.updated === true) {
        this.showAlert()
      }
      this.getUsers()
    },
    methods: {
      countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert () {
        this.dismissCountDown = this.dismissSecs
      },
      getUsers (status) {
        this.loading = true
        const url = status !== undefined ? `?status=${status}` : ``
        this.$http.get(`users${url}`)
          .then(response => {
            this.items = response.data.users
            this.items.forEach(item => {
              item.created_at = ''
              item.updated_at = ''
              item.actions = {show: true, id: item.id, route: 'Participante'}
              switch (item.register_email) {
                case 'success':
                  item.register_email = 'Enviado'
                  break;
                case null:
                  item.register_email = 'Não enviado'
                  break;

                default:
                  break;
              }
            })
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/participants/List.vue